
export const initializeZoho = () => {
    if (typeof window !== 'undefined') {
        window.$zoho = window.$zoho || {};
        window.$zoho.salesiq = window.$zoho.salesiq || { ready: function () {} };
    }
};
